<!-- El formGroup se declara aquí porque este template vive dentro de un componente hijo. -->
<div
  class="form-row"
  *ngIf="ctx.isMxnDeclaredCashin"
  [formGroup]="ctx.declarationCashinForm"
>
  <div class="filter-column">
    <div class="form-item">
      <label for="mxn_cashin_firstname">Nombre(s) beneficiario</label>
      <input
        id="mxn_cashin_firstname"
        type="text"
        placeholder="Ingresa los nombres"
        formControlName="firstname"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="mxn_cashin_lastname">Apellidos beneficiario</label>
      <input
        id="mxn_cashin_lastname"
        type="text"
        placeholder="Ingresa los apellidos"
        formControlName="lastname"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="mxn_cashin_protocol">Protocolo SPEI</label>
      <p-dropdown
        id="mxn_cashin_protocol"
        formControlName="protocol"
        [options]="bitsoMxProtocolOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      />
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="mxn_cashin_clabe">{{ bitsoMxClabeLabel }}</label>
      <input
        id="mxn_cashin_clabe"
        type="text"
        [placeholder]="bitsoMxClabePlaceholder"
        formControlName="clabe"
        pInputText
        class="id-input-filter"
        autocomplete="off"
      />
    </div>

    <div class="form-item" *ngIf="needsInstitutionCode">
      <label for="mxn_cashin_inst">Código de institución (banco)</label>
      <input
        id="mxn_cashin_inst"
        type="text"
        placeholder="Ej. 40002"
        formControlName="institution_code"
        pInputText
        class="id-input-filter"
        autocomplete="off"
      />
    </div>

    <div class="form-item">
      <label for="mxn_cashin_rfc">RFC (opcional recomendado)</label>
      <input
        id="mxn_cashin_rfc"
        type="text"
        placeholder="Ej. PESJ590317IG4"
        formControlName="rfc"
        pInputText
        class="id-input-filter"
        autocomplete="off"
      />
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="mxn_cashin_numref"
        >Referencia numérica (máx. 7 dígitos, opcional)</label
      >
      <input
        id="mxn_cashin_numref"
        type="text"
        inputmode="numeric"
        maxlength="7"
        formControlName="numeric_ref"
        pInputText
        class="id-input-filter"
      />
    </div>
  </div>
</div>
